import { HttpBackend, HttpClient, HttpInterceptor } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { UNAUTHENTICATED_HTTP_INTERCEPTORS } from '@app/http-interceptors';
import { HttpInterceptingHandler } from '@app/http-interceptors/http-intercepting-handler';

@Injectable({
  providedIn: 'root',
})
export class UnauthenticatedHttpClient extends HttpClient {
  // NOTE: When injected, `HttpBackend` dispatches requests directly to the backend, without going through the interceptor chain.
  // Hence need to add the portal version logic as in `PortalVersionHttpInterceptor`
  constructor(
    httpBackend: HttpBackend,
    @Inject(UNAUTHENTICATED_HTTP_INTERCEPTORS) httpInterceptors: HttpInterceptor[]
  ) {
    let handler = new HttpInterceptingHandler(httpBackend, httpInterceptors);
    super(handler);
  }
}
